import { useEffect, useMemo, useState } from 'react';
import cx from 'classnames';
import Image from "next/image";
import { useRouter } from 'next/router';
import { BackgroundColor, generateAccessoriesImage, generateSparePartImage } from 'utils/image.utils';
import 'swiper/css';
import 'swiper/css/pagination';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, setPeopleAlsoBoughtModal } from 'redux/features/bag/bagSlice';
import { addToCart, setPeopleAlsoBought } from 'redux/features/cart/cartSlice';
import { v4 as uuidv4 } from 'uuid';
import Spinner from 'components/Spinner/Spinner';
import { RootState } from 'redux/store';
import { getAccessorieName } from 'functions/getProductName';
import { imageLoader } from 'functions/imageLoader';
import { getSession } from 'functions/session';


const CartAccessoryRecommended = ({
    product,
}: { product: any }) => {

    const cdnImage = useMemo(() => {
        const dataProduct = product || [];
        if (dataProduct?.name?.includes?.('Arms')) {
            let [, color] = dataProduct.name.split(' - ');
            [color] = color.split(',');
            return generateSparePartImage(color.toLowerCase()) as string;
        } else if (dataProduct?.hasVariation) {
            return generateAccessoriesImage(getAccessorieName(dataProduct?.name));
        }
        return generateAccessoriesImage(dataProduct?.slug);
    }, [product]);

    const productName = useMemo(() => {
        return product?.name
    }, [product]);

    const [salePrice, setSalePrice] = useState(0);
    const [regularPrice, setRegularPrice] = useState(0);

    useEffect(() => {
        if (product) {
            setSalePrice(product.meta.price);
            setRegularPrice(product.meta.regular_price);
        }
    }, [product]);


    const dispatch = useDispatch();
    const uuidV4 = uuidv4();
    const isLoad = useSelector((state: RootState) => state.bagEvent.loading);
    const router = useRouter();
    return (
        <>
            <div
                className="group flex h-full flex-col rounded-[8px] bg-white p-[8px] text-brand-black100 transition-shadow duration-500 sm:p-[20px] sm:pb-[24px] sm:hover:shadow-card">
                <div className="h-[275px] w-full cursor-pointer" onClick={() => {
                    router.push(`/shop/accessories/${product.slug}`)
                }}>
                    <div
                        className={`relative h-[240px] w-full animate-opacityinquick`}>
                        <Image
                            quality={85}
                            fill
                            style={{
                                objectFit: "cover",
                            }}
                            sizes="230px"
                            loader={imageLoader}
                            src={cdnImage}
                            onError={(ev) => ev.currentTarget.src = 'https://cdn.dresden.vision/images/noimage.png'}
                            title={productName}
                            alt={productName}
                        />
                    </div>
                </div>
                <div className="flex flex-auto flex-col items-center justify-between">
                    <span className="text-16px mt-[8px] flex-auto text-center leading-[17px]">
                        {getAccessorieName(productName)}
                    </span>
                    <span className="mt-[8px] font-medium">
                        {salePrice != regularPrice ? (
                            <>
                                <span className="text-12px line-through text-brand-grey400 mr-[8px]">
                                    ${regularPrice}
                                </span>
                                <span
                                    className={cx({
                                        'text-brand-green': salePrice != regularPrice
                                    })} dangerouslySetInnerHTML={{ __html: '$' + (salePrice) }}>
                                </span>
                            </>
                        ) : (
                            <span dangerouslySetInnerHTML={{ __html: '$' + (salePrice) }}></span>
                        )}
                    </span>
                    <span onClick={() => {
                        const extraData = {
                            productName: product.name,
                            productLink: `/shop/accessories/${product.slug}`,
                            productType: 'accessories',
                            imagePath: cdnImage
                        };

                        const session = getSession();
                        if (session) {
                            dispatch(setLoading(true));
                            dispatch(addToCart({
                                type: 'simple',
                                variables: {
                                    queueId: uuidV4,
                                    input: {
                                        productId: product.post_id,
                                        clientMutationId:
                                            getSession(),
                                        quantity: 1,
                                        extraData: JSON.stringify(extraData)
                                    }
                                }
                            }));
                            dispatch(setPeopleAlsoBought(true));
                        }
                    }} className="mt-[16px] h-[40px] w-[140px] cursor-pointer rounded-[6px] border border-brand-grey400 text-center font-medium leading-[35px] transition-colors duration-500 sm:group-hover:text-brand-orange">
                        <span className="flex items-center  justify-center ">
                            {isLoad && (
                                <span className="mr-2 mt-[1px]">
                                    <Spinner fill="black" />
                                </span>
                            )}
                            <span>
                                Add to cart
                            </span>
                        </span>

                    </span>
                </div>
            </div>
        </>
    );
};

export default CartAccessoryRecommended;
